import { useEffect } from 'react'
import { paletteCss, type Palette } from '../../shared/palette'

// The owner's colours (Admin → Colours) laid over the theme as one small stylesheet. This device keeps the last one
// so public/theme.js can put it in place before the first paint, and a changed palette never flashes the old colours.
const KEY = 'gatheredfrom:palette'
const ID = 'gatheredfrom-palette'

export function applyPalette(palette: Palette | undefined) {
  const css = palette ? paletteCss(palette) : ''
  let sheet = document.getElementById(ID)
  if (!sheet) {
    sheet = document.createElement('style')
    sheet.id = ID
    document.head.append(sheet)
  }
  if (sheet.textContent !== css) sheet.textContent = css
  // The browser's own bars follow the page, as applyTheme sets them.
  const background = getComputedStyle(document.documentElement).getPropertyValue('--background').trim()
  if (background)
    for (const meta of document.querySelectorAll('meta[name="theme-color"]')) meta.setAttribute('content', background)
  try {
    if (css) localStorage.setItem(KEY, css)
    else localStorage.removeItem(KEY)
  } catch {
    // Storage can be off (private browsing); the colours still come with the account.
  }
}

// The saved palette, kept in place while the app runs. Signed out, the one this device last saw stays.
export function usePalette(palette: Palette | undefined, theme: string) {
  const css = palette ? paletteCss(palette) : null
  useEffect(() => {
    if (palette) applyPalette(palette)
    // Redone when light or dark changes, so the status bar takes the right background.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [css, theme])
}
